import LoadingSpinner from 'components/LoadingSpinner'
import React, { createContext, useState } from 'react'
const LoadingContext = createContext(null)
export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      <LoadingSpinner isLoading={isLoading} />
      {children}
    </LoadingContext.Provider>
  )
}
export default LoadingProvider
export { LoadingContext }
